import { User } from "./user";

export class Candidate extends User {
}
